import { TEMPLATES_WRITE_ROLES } from "../../../utils/constants";

export const canWriteCreativeTemplates = ({ role }) =>
  TEMPLATES_WRITE_ROLES.includes(role);
